<div class="container container-shadow pt-4 pb-5 my-4 mb-4">
    <h3 class="text-center">Embedded Image Supported Email Clients</h3>
    <div class="row mb-4">
        <div class="col"><span>No. of domains listed: {{ maxCount }}</span></div>
        <div class="col">
            <div class="float-right"><a type="button" class="btn btn-primary" href="/newsletters">Back to Newsletters</a></div>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col">
            <div class="float-left">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text"> Domain Name </span>
                    </div>
                    <input name='domain_name' ngDefaultControl type="text" class="form-control" [(ngModel)]="domainName" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" />
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <input name='email_embedded_image_support' ngDefaultControl type="checkbox" [(ngModel)]="emailEmbeddedImageSupport" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">&nbsp;
                            <span>Embedded Image Support</span>
                        </div>
                        <button class="btn btn-outline-secondary" type="button" (click)="createDomain()">Add</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="float-right">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text"> Domain Name </span>
                    </div>
                    <input name='search_term' ngDefaultControl id="typeahead-basic" type="text" class="form-control" [(ngModel)]="searchTerm" [ngbTypeahead]="search" (keyup)="autoComplete()"/>
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" (click)="searchDomains()">Search</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col">
            <div class="float-left"><span>Do not add http:// or https:// before domain</span></div>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col">
            <pagination
                (pageChanged)="index($event)"
                class="pagination-sm"
                [boundaryLinks]="true"
                [totalItems]="maxCount"
                [maxSize]="paginateParams.per_page"
                [itemsPerPage]="paginateParams.per_page"
                [(ngModel)]="paginateParams.page"
                previousText="&lsaquo;"
                nextText="&rsaquo;"
                firstText="&laquo;"
                lastText="&raquo;"
            ></pagination>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col">
            <table class="table">
                <thead>
                    <tr>
                        <th>S.No.</th>
                        <th>Domain Name</th>
                        <th>Embedded Image Support</th>
                        <th>Remove</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let domain of domains">
                        <td>{{domains.indexOf(domain) + 1 }}</td>
                        <td>{{domain.name}}</td>
                        <td>
                            <span *ngIf="domain.embedded_image_support">
                                <i class="fas fa-check"></i>
                            </span>
                            <span *ngIf="!domain.embedded_image_support">
                                <i class="fas fa-times"></i>
                            </span>
                            &nbsp;
                            <span class="text-primary" (click)="updateDomain(domain.id, domain.embedded_image_support)" type="button">Change</span>
                        </td>
                        <td>
                            <button type="button" class="btn btn-danger" [disabled]="domain.isDeleting" (click)="deleteDomain(domain, domain.id)">
                                {{ domain.isDeleting ? 'Deleting' : 'Delete' }}<span *ngIf="domain.isDeleting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col">
            <pagination
                (pageChanged)="index($event)"
                class="pagination-sm"
                [boundaryLinks]="true"
                [totalItems]="maxCount"
                [maxSize]="paginateParams.per_page"
                [itemsPerPage]="paginateParams.per_page"
                [(ngModel)]="paginateParams.page"
                previousText="&lsaquo;"
                nextText="&rsaquo;"
                firstText="&laquo;"
                lastText="&raquo;"
            ></pagination>
        </div>
    </div>
</div>